import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from 'pubsub-js';
import {useNavigate } from "react-router-dom";
import { validationMessages } from "../../utils/messages";
import { regExPattern } from "../../utils/regExPattern";
import { useEffect } from "react";

// Define initial errors i.e. required field and their message
const initialErrors = {
  name: { message: validationMessages.categoryName.required},
};

const CategoryEdit = (props) => {

  const [validated, setValidated] = useState(false);
  const [category, setCategory] = useState(props ? props.category : {});

  //errors state
  const [errors, setErrors] = useState(!props.category ? initialErrors : {});
  const navigate = useNavigate();

  useEffect(()=>{
    if(!category.id){
      setCategory({ ...category, isactive : false});
    } 
},[])
 
  const checkRequiredFields = () => {

     if (
      category.name &&
      category.name.trim() !== "" 
    ) {
     
      return false;
    }

    let isError = false;

         // handle errors for required fields
            if (!category?.name) {
              setErrors((prev) => ({ ...prev, 'name': { message: validationMessages.categoryName.required } }));
              isError = true;
            }
    return isError;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
   

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    if (Object?.keys(errors)?.length != 0) {
      console.log("Object?.keys(errors)?.length",Object?.keys(errors)?.length);
      setValidated(true);
      return;
    }
    let result2 = {};

    if (category.id) {
      result2 = await trasportApi.saveCategories(category);
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Updated', message: 'Record updated successfully' });
      }
    } else {
      result2 = await trasportApi.createCategory(category); 
      console.log('category.isactive',category.isactive);
      if (result2?.id) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record saved successfully' });
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }
    props.submitCategoryList();
  };

  const handleChange  = async (e) => {
    const { name, value } = e.target;
    if (name == "name") {
         if (value == "") {
           setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.categoryName.required } }));
         } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
           setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.categoryName.invalid } }));
         } else {
           setErrors((prev) => {
             delete prev[name];
             return { ...prev };
           });
         }
       }
       setValidated(true);
       setCategory((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Modal {...props} size="lg" backdrop="static"keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
        Category
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                noValidate
                validated={validated}
              >
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">Category Name</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="name"
                        pattern={regExPattern.name}
                        placeholder="Enter Category Name"
                        value={category.name}
                        onChange={handleChange}
                        style={{ height: "38px" }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.name?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  {/* <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Is Active
                      </Form.Label>
                      <Form.Check
                        type="checkbox"
                        checked={category.isactive ? true : false}
                        value={category.isactive}
                        onClick={(e) => {
                          setCategory({
                            ...category,
                            [e.target.name]: e.target.checked,
                          });
                        }}
                        name="isactive"
                      />
                    </Form.Group>
                  </Col> */}
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light" className="btn-delete">
          Cancel
        </Button>
        <Button variant="primary" className="btn-edit" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default CategoryEdit;
